import React, { useState, useRef } from 'react';
import { Link } from "react-router-dom";


const Navbar = () => {

  return (
    <nav className="flex justify-between items-center py-6 px-6 xl:px-16 2xl:px-28 relative z-10">
      <Link to='/' aria-label='qlite logo'>
        <img tabIndex={0} className='cursor-pointer w-16 md:w-20 mx-auto lg:ml-0 brightness-0' src='../images/qlite-logo.webp' alt='qlite logo' />
      </Link>

      {/* Desktop Nav */}
      <div className="flex items-center gap-3">
        <Link to="/login" className="text-[#2B2B2B] px-4 md:px-8 py-3 text-sm inter-600 border md:border-[#2B2B2B] border-white rounded-full hover:text-white md:bg-transparent bg-white hover:bg-primary hover:border-primary transition-all ease-in-out duration-500">
          Login
        </Link>
        <Link to="/getquote"
          className="text-black px-4 md:px-8 py-3 text-sm rounded-full inter-600 bg-gradient-to-b from-[#F2CE64] to-[#EEB50A] 
            hover:from-[#F2CE64]/90 hover:to-[#EEB50A]/90 border border-transparent transition-all ease-in-out duration-500"
          // style={{ background: 'linear-gradient(180deg, #F2CE64 0%, #EEB50A 66.3%)' }}
        >
          Request Demo
        </Link>
      </div>
    </nav>
  );
};

const Hero = () => {
  return (
    <div className="relative pt-10 pb-20 md:pb-32 px-6 md:px-6 md:max-w-6xl 2xl:max-w-7xl mx-auto">
      <div className="relative">
        <h1 className="text-[2.25rem] md:text-[5.25rem] 2xl:text-[6rem] inter-600 text-[#232323] leading-normal md:leading-[7.87rem] 2xl:leading-[8.95rem] md:mb-8">
          Privacy Policy
        </h1>
        <p className="text-gray-900 mb-6">{privacyData.effectiveDate}</p>
      </div>
    </div>
  );
};

const privacyData = {
  effectiveDate: "Effective Date: Jan 2026",
  intro:
    "QLITEX (“we,” “our,” or “us”) respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how information is collected, used, disclosed, and safeguarded when you visit or use the QLITEX website and related services.",
  sections: [
    {
      heading: "1. Information We Collect",
      content: [
        {
          sub: "a. Information You Provide Voluntarily",
          points: [
            "Name, email address, organization, and contact details",
            "Information submitted through forms, inquiries, registrations, or communications",
            "Any other information you choose to provide"
          ]
        },
        {
          sub: "b. Automatically Collected Information",
          points: [
            "IP address, browser type, device information, and operating system",
            "Pages visited, time spent on the site, and referring URLs",
            "Cookies and similar tracking technologies"
          ]
        },
        {
          sub: "c. Third-Party Sources",
          text: "We may receive information from trusted partners or service providers that help us operate, analyze, or improve our services."
        }
      ]
    },
    {
      heading: "2. How We Use Your Information",
      points: [
        "Operate, maintain, and improve the QLITEX website and services",
        "Respond to inquiries and provide customer support",
        "Communicate updates, offerings, or relevant information",
        "Analyze usage trends and improve user experience",
        "Ensure security, compliance, and fraud prevention",
        "Meet legal, regulatory, or contractual obligations",
        "We do not sell personal information."
      ]
    },
    {
      heading: "3. Cookies and Tracking Technologies",
      text:
        "QLITEX uses cookies and similar technologies to improve site functionality, understand user interactions, and maintain session integrity. You may disable cookies through browser settings."
    },
    {
      heading: "4. Data Sharing and Disclosure",
      points: [
        "With service providers under confidentiality obligations",
        "To comply with legal requirements or lawful requests",
        "To protect rights, safety, and security",
        "In connection with a business transaction such as merger or acquisition"
      ]
    },
    {
      heading: "5. Data Security",
      text:
        "We implement administrative, technical, and organizational safeguards to protect your information. While no system guarantees absolute security, we continuously improve our practices."
    },
    {
      heading: "6. Data Retention",
      text:
        "We retain personal information only as long as necessary unless a longer retention period is required by law."
    },
    {
      heading: "7. Your Privacy Rights",
      points: [
        "Access, correct, or delete your personal information",
        "Object to or restrict certain processing",
        "Request data portability where applicable"
      ]
    },
    {
      heading: "8. Third-Party Links",
      text:
        "Our website may contain links to third-party websites. We are not responsible for their privacy practices."
    },
    {
      heading: "9. Children’s Privacy",
      text:
        "QLITEX does not knowingly collect personal information from children under 13. If discovered, it will be deleted."
    },
    {
      heading: "10. Changes to This Privacy Policy",
      text:
        "We may update this policy from time to time. Continued use of the website constitutes acceptance of changes."
    },
    {
      heading: "11. Contact Us",
      contact: {
        email: "support@quantumliteracy.org",
        website: "https://www.qlitex.com"
      }
    }
  ]
};

const FooterCTA = () => {
  return (
    <div className="bg-white mt-10 pb-14 px-6 xl:px-9 2xl:px-18">
      <div className="rounded-[20px] overflow-hidden relative">
        <div className="flex flex-col md:flex-row items-center gap-12 pt-14 md:pt-16"
          style={{ background: 'conic-gradient(from 180deg at 52.29% 50%, #447FFF 0deg, #B442AF 60.00000178813934deg, #E4456B 120.00000357627869deg, #E38025 180deg, #E4456B 240.00000715255737deg, #E4456B 299.9999928474426deg, #203BC7 360deg)' }}
        >

          <div className="md:w-[45%] text-white px-4 md:pl-12 md:pr-0">
            <h2 className="text-3xl md:text-5xl leading-tight tracking-[-1.92px] inter-700 mb-4 md:mb-6">Ready to explore & Start your Quantum journey</h2>
            <p className="text-black text-base inter-400 mb-10 md:mb-14 max-w-lg">Book a demo to review student outcomes, teacher workflows, and implementation options that scale across classrooms.</p>
            <div className="flex">
              <Link to="/getquote"
                className="w-full md:w-auto text-center text-black px-8 py-4 text-base bg-[#EFB731] hover:bg-white rounded-full inter-600 transition-all ease-in-out duration-500"
              >
                Request a Demo
              </Link>
            </div>
          </div>

          <div className="flex-1 w-auto relative pl-4 md:pl-0">
            {/* Dashboard Mockup Image Placeholder */}
            <div className="rounded-[20px] w-full">
              <img src="/images/home/explore-dashboard.webp" alt="Dashboard" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Footer = () => (
  <footer className="bg-white pb-8 px-6 xl:px-16 2xl:px-28">
    <div className="border-t-2 border-[#F58728] pt-8 md:pt-11 flex flex-col md:flex-row justify-between md:items-end gap-6 md:gap-0">
      <div className="">
        <Link to='/' aria-label='qlite logo'>
          <img tabIndex={0} className='cursor-pointer w-[6.625rem] md:w-20 md:mx-auto lg:ml-0 brightness-0' src='../images/qlite-logo.webp' alt='qlite logo' />
        </Link>
        <p className="text-base text-black mt-6">Powdered by Ina Solutions Inc.</p>
      </div>
      <div className="flex flex-wrap items-center gap-3 md:gap-0">
        <a href="mailto:sales@quantumliteracy.org" className="group text-sm inter-500 text-black hover:text-primary flex items-center gap-2 md:border-r border-black pr-4 transition-all ease-in-out duration-500">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path className="group-hover:fill-primary transition-all ease-in-out duration-500" d="M12.9592 10.8301L11.2842 12.5108C10.6049 13.1924 9.40979 13.2071 8.71584 12.5108L7.04073 10.8301L1.02448 16.8659C1.24842 16.9694 1.49533 17.0312 1.75783 17.0312H18.2422C18.5047 17.0312 18.7515 16.9695 18.9754 16.8659L12.9592 10.8301Z" fill="black"/>
            <path className="group-hover:fill-primary transition-all ease-in-out duration-500" d="M18.2422 2.96875H1.75782C1.49532 2.96875 1.2484 3.03055 1.02454 3.1341L7.45333 9.58422C7.45375 9.58465 7.45426 9.58473 7.45469 9.58516C7.45512 9.58559 7.4552 9.58617 7.4552 9.58617L9.54555 11.6834C9.76758 11.9055 10.2325 11.9055 10.4545 11.6834L12.5445 9.58652C12.5445 9.58652 12.545 9.58559 12.5454 9.58516C12.5454 9.58516 12.5463 9.58465 12.5468 9.58422L18.9754 3.13406C18.7515 3.03047 18.5047 2.96875 18.2422 2.96875Z" fill="black"/>
            <path className="group-hover:fill-primary transition-all ease-in-out duration-500" d="M0.186953 3.95361C0.0710937 4.18791 0 4.44799 0 4.72658V15.2735C0 15.5521 0.0710156 15.8121 0.186914 16.0464L6.21359 10.0002L0.186953 3.95361Z" fill="black"/>
            <path className="group-hover:fill-primary transition-all ease-in-out duration-500" d="M19.813 3.95361L13.7864 10.0003L19.813 16.0466C19.9289 15.8123 20 15.5522 20 15.2735V4.72666C20 4.44799 19.9289 4.18791 19.813 3.95361Z" fill="black"/>
          </svg>
          sales@quantumliteracy.org
        </a>
        <span className="md:px-4 md:border-r border-black">© Copyright National Quantum Literacy Network, USA</span>
        <a href="/privacy-policy" className="md:pl-4 text-sm text-[#3A3A3A] hover:text-primary inter-500 transition-all ease-in-out duration-500">Privacy Policy</a>
      </div>
    </div>
  </footer>
);

export default function Privacy() {
  return (
    <div className="min-h-screen font-sans text-gray-900 relative">
      {/* Top Gradient Background */}
      <div className="absolute top-0 left-0 w-full h-[6%] md:h-[10%] -z-10 md:rounded-b-[5rem] overflow-hidden">
        <img
          src="/images/home/qlite-banner.webp"
          alt="Hero Background"
          className="w-full h-full object-cover md:block hidden"
        />
        <img
          src="/images/home/qlite-banner-mob.webp"
          alt="Hero Background"
          className="w-full h-full object-cover md:hidden block"
        />
      </div>

      <Navbar />
      <Hero />

      {/* privacy content start */}
      <div className="px-6 md:px-6 md:max-w-6xl 2xl:max-w-7xl mx-auto pb-20">
        <p className="mb-10 text-lg leading-7">{privacyData.intro}</p>

        {privacyData.sections.map((section, index) => (
          <div key={index} className="mb-10">
            <h3 className="text-xl md:text-2xl inter-600 mb-4">
              {section.heading}
            </h3>

            {/* paragraph */}
            {section.text && (
              <p className="mb-4 leading-7">{section.text}</p>
            )}

            {/* sub content */}
            {section.content &&
              section.content.map((item, i) => (
                <div key={i} className="mb-4">
                  {item.sub && (
                    <h4 className="font-semibold mb-2">{item.sub}</h4>
                  )}

                  {item.text && <p className="mb-2">{item.text}</p>}

                  {item.points && (
                    <ul className="list-disc pl-6 space-y-1">
                      {item.points.map((p, pi) => (
                        <li key={pi}>{p}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

            {/* bullet points */}
            {section.points && (
              <ul className="list-disc pl-6 space-y-2">
                {section.points.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            )}

            {/* contact */}
            {section.contact && (
              <div className="mt-3">
                <p>Email: {section.contact.email}</p>
                <p>Website: <a href={section.contact.website} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">{section.contact.website}</a></p>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* privacy content end */}
      <FooterCTA />
      <Footer />
    </div>
  );
}